import clsx from "clsx";
import React, { useState } from "react";
import { Col, Row, Accordion } from "react-bootstrap";

interface FaqData {
  question: string;
  answer: string;
}

interface FaqProps {
  data: FaqData[];
}

function Faq({ data }: FaqProps) {
  const [activeIndex, setActiveIndex] = useState(-1);
  return (
    <Row className='my-50 sm-mt-0 '>
      <Col className='my-auto text-center text-lg-start' lg={4}>
        <h2 className='bold  d-flex flex-column gap-2  faq-head sm-30px'>
          Frequently <br />
          <span className='text-gradient sm-mt-0 faq-grad'>Asked Questions</span>
        </h2>
        <p className='text-muted'>Answers to the burning questions in your mind.</p>
      </Col>
      <Col lg={8} className='ps-md-4'>
        <Accordion className='faq-acc'>
          {data?.map((item, index: number) => (
            <Accordion.Item key={index} eventKey={index.toString() as string}>
              <Accordion.Header
                className='pe-2'
                onClick={() => (activeIndex === index ? setActiveIndex(-1) : setActiveIndex(index))}
              >
                <span
                  className={clsx("index mr-8", {
                    active: activeIndex === index,
                  })}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                    fill='none'
                  >
                    <circle cx='8' cy='8' r='6' stroke='#C3C3D0' strokeWidth='4' />
                  </svg>
                </span>
                {item.question}
              </Accordion.Header>
              <Accordion.Body className=''>{item.answer}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Col>
    </Row>
  );
}

export default Faq;
